export default __webpack_public_path__ + "88b3178.png";